import { render, staticRenderFns } from "./DeliveryNotes.vue?vue&type=template&id=376edcf9&scoped=true"
import script from "./DeliveryNotes.vue?vue&type=script&lang=js"
export * from "./DeliveryNotes.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNotes.vue?vue&type=style&index=0&id=376edcf9&prod&lang=css"
import style1 from "./DeliveryNotes.vue?vue&type=style&index=1&id=376edcf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376edcf9",
  null
  
)

export default component.exports